import React from 'react'

import { StyledBadge } from '../UserInfo/styles'

import useStyles from './styles'

interface MessageSkeletonV2Props {
  isYours?: boolean
}
const MessageSkeletonV2: React.FC<MessageSkeletonV2Props> = ({ isYours }) => {
  const classes = useStyles({ isYours })

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <StyledBadge overlap='rectangular' className={classes.avatarLoading}>
          <span></span>
        </StyledBadge>
        <div className={classes.dividerContent}></div>
      </div>
      <div className={classes.container}>
        <div className={classes.msgContent}></div>
      </div>
    </div>
  )
}
export default React.memo(MessageSkeletonV2)
